import {
  CircularProgress,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { convertToBase64 } from "utils/imageUtils";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "firebaseApp";
import { updateDoc, doc } from "firebase/firestore";
import SectionContainer from "components/ai-editor/SectionContainer";
import PasteImageMenuItem from "components/ai-editor/PasteImageMenuItem";
import AspectRatioImage from "components/ai-editor/AspectRatioImage";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import GenerateImageAltTextButton from "components/ai-editor/GenerateImageAltTextButton";

export const IMAGE_TYPE = {
  key: "image",
  default: {
    image: {},
    altText: "",
  },
};

export const SIZE = 300;

export default function Image({ section, dragHandleProps }) {
  const [localImage, setLocalImage] = useState();
  const [uploading, setUploading] = useState(false);
  const [image, setImage] = useState(section.image);
  const [altText, setAltText] = useState(section.altText || "");

  const handleFileChange = (event) => {
    convertToBase64(event.target.files[0], setLocalImage);
    event.target.value = null;
  };

  const uploadImage = async () => {
    try {
      setUploading(true);
      const response = await httpsCallable(
        functions,
        "uploadBase64Image"
      )({
        fileName: localImage.name,
        base64Image: localImage.base64,
        bucketName: "documentImages",
      });
      const responseData = response.data;
      setImage(responseData);
      await updateDoc(
        doc(db, "documents", section.documentId, "sections", section.id),
        {
          image: responseData,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    if (localImage) {
      uploadImage();
    }
  }, [localImage]);

  const saveAltText = () => {
    updateDoc(
      doc(db, "documents", section.documentId, "sections", section.id),
      {
        altText,
      }
    );
  };

  const renderPreview = () => {
    if (!localImage && !image) return null;
    return (
      <Stack
        position="relative"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        {uploading && (
          <Stack
            position="absolute"
            left={0}
            top={0}
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress />
          </Stack>
        )}
        {/* <img
          src={localImage?.base64 || image?.imageUrl}
          style={{
            maxWidth: `${SIZE}px`,
            maxHeigth: `${SIZE}px`,
          }}
        /> */}
        <AspectRatioImage
          src={localImage?.base64 || image?.imageUrl}
          maxSize={SIZE}
          alt=""
        />
      </Stack>
    );
  };

  const renderButton = () => {
    if (localImage || image?.imageUrl) return null;
    return (
      <IconButton component="label">
        <AddPhotoAlternateIcon />
        <input
          type="file"
          onChange={handleFileChange}
          hidden
          accept="image/*"
          data-testclass="image-uploader-input"
        />
      </IconButton>
    );
  };

  return (
    <SectionContainer
      section={section}
      dragHandleProps={dragHandleProps}
      menuItems={[
        <PasteImageMenuItem
          callback={(blob) => convertToBase64(blob, setLocalImage)}
        />,
      ]}
    >
      <Stack alignItems="center" justifyContent="center" spacing={2}>
        {renderPreview()}
        {renderButton()}
        <Stack direction="row" width="100%" alignItems="center" justifyContent="center">
          <TextField
            sx={{
              flexGrow: 1,
              maxWidth: "500px",
            }}
            size="small"
            label="Alt text / Description"
            multiline
            maxRows={4}
            value={altText}
            onChange={(event) => setAltText(event.target.value)}
            onBlur={saveAltText}
          />
          {/* <IconButton>
            <AutoAwesomeIcon />
          </IconButton> */}
          <GenerateImageAltTextButton
            section={section}
            setAltText={setAltText}
          />
        </Stack>
      </Stack>
    </SectionContainer>
  );
}
